import Reveal from "./Reveal";

const stats = [
  { value: "B2C", label: "notre premier segment de chiffre d'affaires" },
  { value: "Juridique", label: "accompagnement juridique pour structurer ton agence" },
  { value: "100 %", label: "d'indépendance juridique et financière" },
];

export default function Stats() {
  return (
    <section data-testid="stats-section" className="relative py-24 md:py-32 border-t border-emerald-400/10">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14">
          {stats.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.08}>
              <div data-testid={`stat-${i}`} className="border-l border-emerald-400/20 pl-6">
                <p className="font-jbmono font-bold text-4xl md:text-5xl text-emerald-400 tracking-tight">{s.value}</p>
                <p className="mt-3 text-sm text-slate-400 leading-relaxed">{s.label}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
